import { jsx as _jsx } from "react/jsx-runtime";
import { Assembler, getZombieInstanceFromPrimaryKey } from '@iotv/datamodel';
import { genericListViewDefinition, getListViewDefinition, getViewDefinitionFromUserAttributes } from '../../../../components/factories/AttributeDefinitions';
import { ObjectViewType } from '../../../../types/AppTypes';
import ListCard from './ListCard';
const debug = process.env.REACT_APP_DEBUG && false;
const maxItems = 20;
export default function ObjectListCard(props) {
    const { viewObject, transactionFunctions, mostProximateCustomer, userGroupRoles, applicationData, userFunctions, adjacentFilter, listConfigParams, disableLink, } = props;
    debug && console.log('Object List Card userGroupRoles', userGroupRoles);
    const zombie = getZombieInstanceFromPrimaryKey(adjacentFilter.objectType);
    const instance = Assembler.getInstance(zombie);
    const userAttributes = instance?.getUserAttributes?.();
    const knownViewDefinition = getListViewDefinition(zombie.type) ?? (userAttributes ? getViewDefinitionFromUserAttributes(userAttributes) : undefined);
    debug && console.log(`ObjectListCard view defintion`, { instance, userAttribtues: userAttributes, knownViewDefinition });
    const { sk, pk, ...viewDefinition } = knownViewDefinition ?? genericListViewDefinition;
    if (disableLink === true && viewDefinition.name !== undefined) {
        viewDefinition.name.disableLink = true;
    }
    const maxCols = 5;
    const viewDefinitionColumnVisibility = Object.fromEntries(Object.keys(viewDefinition ?? {})
        .slice(maxCols)
        .map((k) => [k, false]));
    const columnVisibilityReferences = {
        dataTableReference: 'ObjectListCard',
        objectTypeId: adjacentFilter.objectType,
        viewType: ObjectViewType.List,
        externalColumnVisibility: viewDefinitionColumnVisibility,
    };
    debug && console.log('ViewObject in ObjectListCard', viewObject.matchedRelatedBySk);
    return (_jsx(ListCard, { viewObject,
        mostProximateCustomer,
        columnVisibilityReferences,
        viewDefinition,
        adjacentFilter,
        applicationData,
        userFunctions,
        transactionFunctions,
        maxItems,
        listConfigParams }));
}
